import { colors } from "../theme/tokens";

const COLORS = {
  accent: { bg: colors.accent,  text: colors.textPrimary },
  green:  { bg: colors.green,   text: '#000' },
  dim:    { bg: colors.surfaceHover, text: colors.textMuted },
};

export default function Badge({ children, color = "accent" }) {
  const c = COLORS[color] || COLORS.accent;
  return (
    <span style={{
      background: c.bg, color: c.text,
      fontSize: 11, fontWeight: 800,
      letterSpacing: 1, padding: "2px 8px",
      borderRadius: 3, textTransform: "uppercase",
    }}>
      {children}
    </span>
  );
}
